import React from 'react';

import thumb1 from '../assets/nokiaThumb.jpg';
import thumb2 from '../assets/fergusonThumb.jpg';
const MoreToRead = () => {
  return (
    <div className="more">
      <div className="more__header">
        <p className="subheadSB">More to read</p>
      </div>
      <a
        href="http://microsoft-nokia.s3-website-us-east-1.amazonaws.com/"
        target="_blank"
        rel="noreferrer"
      >
        <div className="more__articleBox">
          <div className="article">
            <img src={thumb1} alt="blue tower" />
            <div className="paragraph">
              <p className="moreP">
                Microsoft, Intel secure apps without borders in the new hybrid normal
              </p>
            </div>
            <div className="buttonCont">
              <button className="readButton">Read Article</button>
            </div>
          </div>
        </div>
      </a>
      <a
        href="http://microsoft-ferguson.s3-website-us-east-1.amazonaws.com/"
        target="_blank"
        rel="noreferrer"
      >
        <div className="more__articleBox">
          <div className="article">
            <img src={thumb2} alt="blue tower" />
            <div className="paragraph">
              <p className="moreP">A mountaintop view across a sprawling IT landscape</p>
            </div>
            <div className="buttonCont">
              <button className="readButton">Read Article</button>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default MoreToRead;
